<template>
  <div>
    <slot></slot>

    <slot
        v-if="loading"
        name="loading"
    >
      <div
          v-for="i in 3"
          :key="i"
      >
        <v-skeleton-loader type="list-item-avatar-three-line">
        </v-skeleton-loader>
        <v-divider inset></v-divider>
      </div>
    </slot>

    <Info
        v-if="!loading && !error && empty"
        message="Информация не найдена"
        :sub-message="emptyInfo"
    ></Info>

    <Info
        v-if="error"
        :error="error"
    ></Info>

    <v-row
        v-if="!loading && hasMore"
        class="my-2"
    >
      <v-col align="center" >
        <v-btn
            color="pink"
            text
            @click="getPortion()"
        >
          {{error ? 'попробовать снова' : 'показать еще'}}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Info from '@/components/Info'

export default {
  name: 'Paginator',
  components: {Info},
  data () {
    return {
      empty: false,
      error: null,
      hasMore: true,
      loading: false
    }
  },
  mounted: function () {
    this.getPortion()
    this.$emit('setAskFn', this.getPortion.bind(this, true))
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    emptyInfo: {
      type: String
    },
    endpoint: {
      required: true,
      type: String
    },
    limit: {
      default: 50,
      type: Number
    },
    transformParams: {
      default: function (params) {return params},
      type: Function
    }
  },
  methods: {
    getPortion: function (force = false) {
      this.$emit('beforeLoad')
      this.error = null
      this.loading = true
      this.$client.get(this.endpoint, {params: this.transformParams({limit: this.limit, offset: force ? 0 : this.data.length})})
        .then(data => {
          this.empty = data.size === 0
          this.hasMore = data.items.length === this.limit
          this.$emit('load', data)
        })
        .catch(err => {
          this.error = err
          this.$emit('error', err)
        })
        .then(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
